module.exports = "<h1>Hello {{ name }}</h1>\n<p>I'm a component !</p>\n<p>Just to say, \"Jack\" is a template binding value!</p>\n"